<template>
    <div class="modal fade" id="link-groups-to-figure-modal" tabindex="-1" role="dialog" aria-labelledby="link-groups-to-figure-modal"
         aria-hidden="true">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">{{ __('link_groups.header') }}</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>

                <form id="link-groups-form" action="" method="post" @submit.prevent="linkGroups">
                    <div class="modal-body">
                        <error-message :error="error"></error-message>

                        <div v-if="!modelId" key="selectModel">
                            {{ __('link_groups.text.select_model') }}
                        </div>
                        <div v-else-if="filteredGroups != null && filteredGroups.length > 0" key="filteredGroups" class="form-group">
                            <label>{{ __('model.group.name', { count: 2 }) | capitalize }}</label>
                            <transition-group name="list-complete" tag="div">
                                <div class="custom-control custom-checkbox list-complete-item" v-for="group in filteredGroups" :key="group.id">
                                    <input type="checkbox" :id="'link-check-' + group.id" class="custom-control-input" name="select-group"
                                           v-model="selectedGroupIDs" :value="group.id">
                                    <label :for="'link-check-' + group.id" class="custom-control-label">{{ group.number }}: {{ group.name }}</label>
                                </div>
                            </transition-group>
                        </div>
                        <div v-else-if="globalVars.isLoading" key="loading-groups">
                            {{ __('text.loading_models', { model: __('model.group.name', { count: 2 }) }) | capitalize }} <i class="fas fa-circle-notch fa-spin"></i>
                        </div>
                        <div v-else key="no-filtered-groups">
                            {{ __('link_groups.text.already_linked') }}
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">{{ __('button.close') }}</button>
                        <button type="submit" class="btn btn-primary" :disabled="globalVars.isLoading">{{ __('link_groups.button.save') }}</button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
    import ErrorMessage from '../ErrorMessage';

    export default {
        components: {
            ErrorMessage,
        },
        emits: [
            'groups:linked',
        ],
        props: {
            modelId: {
                type: Number,
                default: null,
            },
            linkedGroups: {
                type: Array,
                default() {
                    return [];
                },
            },
        },
        data() {
            return {
                error: new _Error(),
                allGroups: [],
                selectedGroupIDs: [],
            };
        },
        watch: {
            modelId: {
                immediate: true,
                handler() {
                    this.getAllGroups();
                },
            },
        },
        computed: {
            filteredGroups() {
                if (!this.linkedGroups) return this.allGroups;

                const linkedGroupIds = this.linkedGroups.map(group => group.id);

                return this.allGroups.filter(group => !linkedGroupIds.includes(group.id));
            },
        },
        created() {
            let self = this;

            $(function () {
                $('#link-groups-to-figure-modal').on('hidden.bs.modal', () => {
                    self.error = new _Error();
                    self.selectedGroupIDs = [];
                    self.resetForm('link-groups-form');
                });
            });
        },
        methods: {
            getAllGroups() {
                axios
                    .get('/api/groups')
                    .then(response => {
                        this.allGroups = response.data.result;
                    })
                    .catch(error => {
                        this.error = this.createErrorFromRequest(error);
                    })
                ;
            },
            linkGroups() {
                if (this.selectedGroupIDs && this.selectedGroupIDs.length > 0) {
                    axios
                        .put(`/api/models/${this.modelId}/groups`, {
                            group_ids: this.selectedGroupIDs,
                        })
                        .then(response => {
                            this.error = response.data.error;
                            this.selectedGroupIDs = [];

                            if (response.status === HTTP_CREATED) {
                                this.$emit('groups:linked', this.selectedGroupIDs);
                            }
                        })
                        .catch(error => {
                            this.error = this.createErrorFromRequest(error);
                        })
                    ;
                }
            },
        },
    };
</script>
